import { sessionStorage } from '@shared/helpers/storage'

const fromAppKey = 'kwcFromApp'

export const isFromApp = () => !!sessionStorage.getItem(fromAppKey)

export const setFromApp = (enabled) => {
  if (enabled) {
    sessionStorage.setItem(fromAppKey, '1')
    return
  }

  sessionStorage.removeItem(fromAppKey)
}

export const fromAppToStorage = () => {
  setFromApp(true)
}
